import { render } from "./cek-gaji.vue?vue&type=template&id=25a8ce4a"
import script from "./cek-gaji.vue?vue&type=script&lang=js"
export * from "./cek-gaji.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__